import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "white",
        paddingTop: "90px",
        paddingBottom: "90px",
        paddingLeft: "110px",
        paddingRight: "110px",
        borderRadius: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
        },
    },
}));
const Level2BoxContainer = ({ className, children, }) => {
    const classes = useStyles();
    return React.createElement("div", { className: clsx(classes.root, className) }, children);
};
export default Level2BoxContainer;
